// extracted by mini-css-extract-plugin
module.exports = {"container":"part-exchange-menu_container__3U2a7","faqList":"part-exchange-menu_faqList__n1Awc"};